import { render } from "./BlogMagentoVSWooCommerce.vue?vue&type=template&id=8e7b6a86"
import script from "./BlogMagentoVSWooCommerce.vue?vue&type=script&lang=js"
export * from "./BlogMagentoVSWooCommerce.vue?vue&type=script&lang=js"

import "./BlogMagentoVSWooCommerce.vue?vue&type=style&index=0&id=8e7b6a86&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__